import request from '@/utils/request'

const getCurrentUserTrainings = () => {
  return request({
    url: `${process.env.VUE_APP_FACEBOOK_API}/training/current-user-trainings`,
    method: 'get'
  })
}

export default {
  getCurrentUserTrainings
}
